import AdminOperationsScreen from "../../../src/features/arrangements/screens/AdminOperationsScreen";

export default function CaseDocumentsRoute() {
  return <AdminOperationsScreen screenIdOverride="document-library" />;
}
